"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_1 = require("fabric");
var Base_1 = __importDefault(require("./Base"));
var shourcutsManager_1 = __importDefault(require("../utils/shourcutsManager"));
var constants_1 = require("../common/constants");
var Events = /** @class */ (function (_super) {
    __extends(Events, _super);
    function Events(props) {
        var _this = _super.call(this, props) || this;
        _this.onDoubleClick = function (event) {
            var subTarget = event.subTargets[0];
            if (subTarget) {
                _this.editor.objects.select(subTarget.id);
            }
        };
        _this.onMouseDown = function (e) {
            _this.editor.objects.pasteStyle();
            if (e.button === 3) {
                _this.state.setContextMenuRequest({ left: e.e.offsetX, top: e.e.offsetY, target: e.target });
            }
            else {
                _this.state.setContextMenuRequest(null);
            }
        };
        _this.objectModified = function (event) {
            var target = event.target;
            if (target instanceof fabric_1.fabric.Textbox) {
                _this.scaleTextbox(target);
            }
            _this.editor.history.save();
        };
        _this.onMouseOut = function () {
            _this.canvas.renderAll();
        };
        _this.onMouseWheel = function (event) {
            var isCtrlKey = event.e.ctrlKey;
            if (isCtrlKey) {
                _this.handleZoom(event);
            }
        };
        _this.handleZoom = function (event) {
            var delta = event.e.deltaY;
            var zoomRatio = _this.canvas.getZoom();
            if (delta > 0) {
                zoomRatio -= 0.02;
            }
            else {
                zoomRatio += 0.02;
            }
            _this.editor.zoom.zoomToPoint(new fabric_1.fabric.Point(_this.canvas.getWidth() / 2, _this.canvas.getHeight() / 2), zoomRatio);
            event.e.preventDefault();
            event.e.stopPropagation();
        };
        _this.onBackgroundSelected = function () {
            var objects = _this.canvas.getObjects();
            var frame = objects[0];
            _this.canvas.setActiveObject(objects[0]);
            _this.state.setActiveObject(frame);
            _this.canvas.requestRenderAll();
        };
        _this.handleSelection = function (target) {
            if (target) {
                _this.state.setActiveObject(null);
                var initialSelection = _this.canvas.getActiveObject();
                var isNotMultipleSelection = (initialSelection && initialSelection.type === constants_1.LayerType.GROUP.toLowerCase()) ||
                    (initialSelection && initialSelection.type === constants_1.LayerType.STATIC_VECTOR);
                if (initialSelection && !isNotMultipleSelection && initialSelection._objects) {
                    var filteredObjects = initialSelection._objects.filter(function (object) {
                        if (object.type === constants_1.LayerType.BACKGROUND) {
                            return false;
                        }
                        return !object.locked;
                    });
                    _this.canvas.discardActiveObject();
                    if (filteredObjects.length > 0) {
                        if (filteredObjects.length === 1) {
                            _this.canvas.setActiveObject(filteredObjects[0]);
                            _this.state.setActiveObject(filteredObjects[0]);
                        }
                        else {
                            var activeSelection = new fabric_1.fabric.ActiveSelection(filteredObjects, {
                                canvas: _this.canvas,
                            });
                            _this.canvas.setActiveObject(activeSelection);
                            _this.state.setActiveObject(activeSelection);
                        }
                    }
                }
                else {
                    _this.state.setActiveObject(initialSelection);
                }
            }
            else {
                _this.state.setActiveObject(null);
            }
            _this.canvas.requestRenderAll();
        };
        _this.scaleTextbox = function (target) {
            var fontSize = target.fontSize, width = target.width, scaleX = target.scaleX;
            target.set({
                fontSize: fontSize * scaleX,
                width: width * scaleX,
                scaleX: 1,
                scaleY: 1,
            });
        };
        _this.initialize();
        return _this;
    }
    Events.prototype.initialize = function () {
        this.canvas.wrapperEl.tabIndex = 1;
        this.canvas.wrapperEl.style.outline = "none";
        // @ts-ignore
        this.canvas.on({
            "mouse:dblclick": this.onDoubleClick,
            "mouse:down": this.onMouseDown,
            "mouse:up": this.handleSelection,
            "selection:cleared": this.handleSelection,
            "selection:updated": this.handleSelection,
            "mouse:wheel": this.onMouseWheel,
            "mouse:out": this.onMouseOut,
            "object:modified": this.objectModified,
            "background:selected": this.onBackgroundSelected,
        });
        this.canvas.wrapperEl.addEventListener("keydown", this.onKeyDown.bind(this), false);
    };
    Events.prototype.destroy = function () {
        this.canvas.off({
            "mouse:dblclick": this.onDoubleClick,
            "mouse:down": this.onMouseDown,
            "mouse:up": this.handleSelection,
            "selection:cleared": this.handleSelection,
            "selection:updated": this.handleSelection,
            "mouse:wheel": this.onMouseWheel,
            "mouse:out": this.onMouseOut,
            "object:modified": this.objectModified,
            "background:selected": this.onBackgroundSelected,
        });
        this.canvas.wrapperEl.removeEventListener("keydown", this.onKeyDown.bind(this));
    };
    Events.prototype.onKeyDown = function (event) {
        if (shourcutsManager_1.default.isCtrlZero(event)) {
            event.preventDefault();
            this.editor.zoom.zoomToFit();
        }
        else if (shourcutsManager_1.default.isCtrlMinus(event)) {
            event.preventDefault();
            this.editor.zoom.zoomIn();
        }
        else if (shourcutsManager_1.default.isCtrlEqual(event)) {
            event.preventDefault();
            this.editor.zoom.zoomOut();
        }
        else if (shourcutsManager_1.default.isCtrlOne(event)) {
            event.preventDefault();
            this.editor.zoom.zoomToOne();
        }
        else if (shourcutsManager_1.default.isCtrlZ(event)) {
            this.editor.history.undo();
        }
        else if (shourcutsManager_1.default.isCtrlShiftZ(event)) {
            this.editor.history.redo();
        }
        else if (shourcutsManager_1.default.isCtrlY(event)) {
            this.editor.history.redo();
        }
        else if (shourcutsManager_1.default.isCtrlA(event)) {
            event.preventDefault();
            this.editor.objects.select();
        }
        else if (shourcutsManager_1.default.isDelete(event)) {
            event.preventDefault();
            this.editor.objects.remove();
        }
        else if (shourcutsManager_1.default.isCtrlC(event)) {
            event.preventDefault();
            this.editor.objects.copy();
        }
        else if (shourcutsManager_1.default.isCtrlV(event)) {
            event.preventDefault();
            this.editor.objects.paste();
        }
        else if (shourcutsManager_1.default.isCtrlX(event)) {
            event.preventDefault();
            this.editor.objects.cut();
        }
    };
    return Events;
}(Base_1.default));
exports.default = Events;
//# sourceMappingURL=Events.js.map